import { makeStyles } from '@material-ui/core';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  background: {
    position: 'relative',
    width: '38.06vw',
    backgroundColor: themeColor.lightBackground,
    outline: 0,
    boxShadow: `0 8px 10px -5px ${themeColor.almostwhite}, 0 6px 30px 5px ${themeColor.almostwhite}, 0 16px 24px 2px ${themeColor.semitransparentblack}`,
  },
  logoArea: {
    backgroundColor: themeColor.white,
    paddingRight: '1.14vw',
    height: '10%',
  },
  emeraldContainer: {
    width: 'revert',
  },
  emeraldText: {
    marginLeft: '24.5vh',
    fontSize: '1.15rem',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  xlrText: {
    fontSize: '0.875rem',
    marginLeft: '25.5vh',
    color: themeColor.lockTextColor,
  },
  storeLogo: {
    height: '11vh',
    paddingLeft: '0.5vw',
  },
}));
